/* @flow */
import React from 'react';
// $FlowIgnore
import { connect } from 'react-redux';
import { Row, Column } from 'components/UIKit/Flex';
import { HomeLink } from 'components/Links';

let Footer = ({
  uiVersion,
  uiCommitHash,
  apiCommit,
  apiVersion
}) => {
  return (
    <Column style={{
      width: '100%',
      padding: '1rem',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#123e57',
      borderTop: '6px solid #8c8686',
      marginTop: '3rem',
      color: '#97abb6',
      fontSize: '0.85rem'
    }}
      id="footer"
    >
      <Row>
         <HomeLink>Site Home</HomeLink>
         | <a href="https://www.cancer.gov/policies">Policies</a>
         | <a href="https://www.cancer.gov/policies/accessibility">Accessibility</a>
         | <a href="https://www.cancer.gov/policies/foia">FOIA</a>
         | <a href="https://www.hhs.gov/vulnerability-disclosure-policy">HHS Vulnerability Disclosure</a>
      </Row>
      <Row>
        <a href="https://www.hhs.gov/">U.S. Department of Health and Human Services</a>
         | <a href="https://www.nih.gov/">National Institutes of Health</a>
         | <a href="https://www.cancer.gov/">National Cancer Institute</a>
         | <a href="https://www.usa.gov/">USA.gov</a>
      </Row>
      <Row>
        NIH... Turning Discovery Into Health &#174;
      </Row>

      <Row>
        <div>
          UI <strong>{ uiVersion }</strong> @ <strong>{ uiCommitHash }</strong>,
          API <strong>{ apiVersion }</strong> @ <strong>{ apiCommit.substr(0, 7) }</strong>
        </div>
      </Row>

    </Column>
  );
};

export default connect(state => state.versionInfo)(Footer);
